export const environment: any = {
  production: true,
  baseElasticSearchUrl: "https://search.ganisponsormarket.co.za",
  marketplaceNotificationsApi: "https://1ix2tg5486.execute-api.us-east-1.amazonaws.com/Stage",
  platformEndpoint: "https://sponsorship-api.ganitech.co.za",
  elasticSearchEndpoint: "https://search-ganimarket-yh3o5qb2pzjb7bmddgc43nu75m.us-east-1.es.amazonaws.com",
  esPropertiesIndex: "sponsorship_platform_properties_index",
  esSponsorshipsIndex: "sponsorship_platform_sponsorships_index",
  esSponsorsIndex: "sponsorship_platform_sponsors_index",
  esValuationsIndex: "sponsorship_platform_valuations_index" 
};
